import logo from './logo.svg';
import './App.css';
import Header from './components/Header/Header';
import Member from './components/Header/Member/Member';

function App() {
  return (
    <div>
      <Header></Header>
      <Member></Member>
    </div>
  );
}

export default App;
